import { z } from 'zod';

export const schema = z.object({
  cannabisNaive: z.boolean().optional().nullable(),
  hasAllergy: z.boolean(),
  allergies: z.string().optional().nullable(),
  hasCardioDisease: z.boolean(),
  cardioDisease: z.string().optional().nullable()
});
export type FormFields = z.infer<typeof schema>;
